import { h, FunctionalComponent, Fragment, createRef } from 'preact';
import { DelYeahContainer } from '../../../containers/DelYeahContainer';
import {
  ButtonIconStyled,
  QRButtonLayout,
  LayoutStyled,
  QrInfoStyled,
  RewardOfferItemStyled,
  RewardOffersContentStyled,
  ViewOderOnlineButtonStyled,
  ViewRewardsOffersButtonStyled,
  ViewRewardsOffersStyled, ScanLabel,
} from './scan-code.styles';
import { QR, Button } from '@authentic/loyalty-pwa/components';
import { PrinterIcon } from '../../../icons/Printer';
import { DownloadIcon } from '../../../icons/Download';
import { RewardOfferItem } from './reward-offer-item';
import { ItemStatus, ItemType, RewardOfferItemI } from './reward-offer.types';
import { Link } from 'preact-router/match';
import { useContext, useEffect, useState } from 'preact/hooks';
import { OfferServiceContext, UserProvider, useUser } from '@authentic/loyalty-pwa/providers';
import { OfferResponse } from '@authentic/loyalty-pwa/interfaces';
import { jsPDF } from 'jspdf'
import { svg2pdf } from 'svg2pdf.js'
import { RewardOfferModal } from './reward-offer-modal';
import { Snackbar, SnackbarType } from '../../../components/snackbar/snackbar';
import { link, route } from '@authentic/loyalty-pwa/util';

let offers: RewardOfferItemI[] = [];
let cardId: string = '';
let fullName: string = '';

export const DelYeahScanCode: FunctionalComponent = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarType, setSnackbarType] = useState(SnackbarType.Success);

  const [isActiveRewardOfferDetailModal, setIsActiveRewardOfferDetailModal] = useState(false);
  const [isDisabledSubmitButtonDetailModal, setIsDisabledSubmitButtonDetailModal] = useState(false);
  const [idSelectedItemForDetailModal, setIdSelectedItemForDetailModal] = useState(-1);
  const [selectedItemTitleForDetailModal, setSelectedItemTitleForDetailModal] = useState('');
  const [selectedItemDescriptionForDetailModal, setSelectedItemDescriptionForDetailModal] = useState('');
  const [selectedItemExpirationDateForDetailModal, setSelectedItemExpirationDateForDetailModal] = useState('');
  const [selectedItemImageUrlForDetailModal, setSelectedItemImageUrlForDetailModal] = useState('');

  const [scanPage, setScanPage] = useState(1);
  const offersService = useContext(OfferServiceContext);
  const [itemList, setItemList] = useState(offers);
  const [showOffers, setShowOffers] = useState(false);
  const [itemSelectedId, setItemSelectedId] = useState(-1);
  const htmlTitle: string = 'Scan Code for Del Yeah! Rewards';
  const htmlMetaDescription: string = 'Your Del Yeah! Rewards Dashboard of available rewards and offers.';
  const IDItemMenuSelected: string = '3';
  const getCardIdErrorMessage: string = 'There was an error to get user id.';
  const ref = createRef();
  const user = useUser();

  const callBackSubmit = (data: any) => {
    if (data.id != itemSelectedId) {
      unClipOfferResponse(itemSelectedId, false, data.id);
    }
    setIsDisabledSubmitButtonDetailModal(true);
  };

  const clipOfferResponse = (id: number) => {
    if (id > -1) {
      const offerResponseIndex = offers.findIndex((item) => item.id === id);
      if (offerResponseIndex > -1) {
        if (offers[offerResponseIndex].status === ItemStatus.Active) {
          offersService?.clipOfferResponse(id)
            .then((res: any) => {
              hideModal();
              setIsDisabledSubmitButtonDetailModal(false);
              if (res.success) {
                setItemSelectedId(id);
                getOffersResponses();
              }
              handleResponse(res);
              UserProvider.get().summaryReset();
            });
        } else {
          hideModal();
          setIsDisabledSubmitButtonDetailModal(false);
          setItemSelectedId(id);
          getOffersResponses();
        }
      }
    }
  }

  const clearSelection = (e: any) => {
    e.preventDefault();
    unClipOfferResponse(itemSelectedId, true, -1);
  };

  const unClipOfferResponse = (idToUnclip: number, fromClearSelection: boolean = false, idToClip: number) => {
    if (idToUnclip > -1) {
      const offerResponseIndex = offers.findIndex((item) => item.id === idToUnclip);
      if (offers[offerResponseIndex].status === ItemStatus.Used) {
        offersService?.unclipOfferResponse(idToUnclip)
          .then((res: any) => {
            if (fromClearSelection) {
              setItemSelectedId(-1);
              getOffersResponses();
              UserProvider.get().summaryReset();
            } else {
              clipOfferResponse(idToClip);
            }
            handleResponse(res);
          });
      }
    } else {
      clipOfferResponse(idToClip);
    }
  }

  const viewRewardsOffersCallbackOnClick = () => {
    route('/your-rewards')
  };

  const viewOrderOnlineNowOnClick = () => {
    window.open(link('/order'), '_blank');
  };

  useEffect(() => {
    getOffersResponses();
  }, [scanPage]);

  const getOffersResponses = () => {
    offers = [];
    setShowOffers(false);
    offersService?.getOffersResponses({
      page: scanPage,
      results_per_page: 100,
      sort_by: 'usage_start',
      sort_dir: 'desc',
    }).then((res: any) => {
      if (res.success) {
        res.offers
          .filter((offer: any) => offer.status === 'clipped' || offer.status === 'pending')
          .map((offer: OfferResponse) => {
            offers.push({
              id: offer.id,
              leftImageUrl: offer.thumbnail_url,
              topTitle: offer.subtitle || 'FREE',
              bottomTitle: offer.title,
              callToActionText: 'Tap for details',
              status: (offer.status === 'clipped') ? ItemStatus.Used : ItemStatus.Active,
              expirationDate: formatDate(offer.end_date ? new Date(offer.end_date) : undefined),
              detail: offer.content,
              // Marketer needs to specify an offer if a mobile_reward or an mobile_offer).
              // If there are no categories set, default as offer
              type: (offer.type === 'mobile_reward') ? ItemType.Reward : ItemType.Offer
            });
            if (offer.status === 'clipped') {
              setItemSelectedId(offer.id);
            }
          });

        setItemList(offers);
      } else {
        handleResponse(res);
      }
      setShowOffers(true);
    });
  }

  const print = () => {
    window.print();
  }

  const getQR = () => {
    const qrRef = document.getElementById("qr");
    const tmpPdf = new jsPDF("l", "pt", [230, 230]);

    if (qrRef) {
      svg2pdf(qrRef, tmpPdf, {
        x: 30,
        y: 30,
        width: 200,
        height: 200,
      }).then((res) => {
        if (user.profile && user.summary) {
          tmpPdf.setFontSize(10);
          tmpPdf.text(`ID ${user.profile.card_id}`, 30, 200);
          tmpPdf.text(`${user.summary.first_name} ${user.summary.last_name}`, 30, 18);
          tmpPdf.save(`${user.summary.first_name}_${user.profile.card_id}`);
        }
      });
    }
  };

  const callbackTapForDetails = (data: any) => {
    const offerIndex = offers.findIndex((item) => item.id === data.id);

    if (offerIndex > -1) {
      setSelectedItemImageUrlForDetailModal(offers[offerIndex].leftImageUrl);
      setSelectedItemTitleForDetailModal(offers[offerIndex].bottomTitle);
      setSelectedItemExpirationDateForDetailModal(offers[offerIndex].expirationDate);
      setSelectedItemDescriptionForDetailModal(offers[offerIndex].detail);
      setIsDisabledSubmitButtonDetailModal(data.id === itemSelectedId);
      setIdSelectedItemForDetailModal(data.id);
      setIsActiveRewardOfferDetailModal(true);
    }
  };

  const hideModal = () => {
    setIsActiveRewardOfferDetailModal(false);
  };

  const formatDate = (expirationDate: Date | undefined) => {
    if (expirationDate) {
      const dateItems = (expirationDate.toISOString().substring(0, 10)).split('-');
      return `${parseInt(dateItems[1])}/${dateItems[2]}/${dateItems[0]}`;
    }
    return '';
  };

  const callbackOnCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleResponse = (res: any) => {
    if (res.message) {
      if (res.success) {
        setSnackbarType(SnackbarType.Success);
      } else {
        setSnackbarType(SnackbarType.Error);
      }
      setSnackbarMessage(res.message);
      setOpenSnackbar(true);
    }
  }

  useEffect(() => {
    if (user && user.profile) {
      cardId = user.profile.card_id;
    } else {
      handleResponse({ success: false, message: getCardIdErrorMessage });
    }

    if (user && user.summary) {
      fullName = `${user.summary.first_name} ${user.summary && user.summary.last_name}`
    }
  }, [user]);

  return (
    <DelYeahContainer htmlTitle={htmlTitle} htmlMetaDescription={htmlMetaDescription} IDItemMenuSelected={IDItemMenuSelected}>
      <LayoutStyled>
        <QrInfoStyled>
          <div class="column left" ref={ref} >
            <QR
              id={"qr"}
              content={cardId}
              width={150}
              height={189}
              text={`${fullName}`}
            ></QR>
          </div>
          <div class="column right">
            <ScanLabel type={'desktop'}>
              You can use this code at your Del Taco location to earn or redeem points and offers
              but you’ll need to print or open on your mobile phone.
            </ScanLabel>
            <ScanLabel type={'mobile'}>
              Use this code at your Del Taco location to earn or redeem points and offers. Make sure your screen brightness is turned up before scanning.
            </ScanLabel>

            <QRButtonLayout>
              <ButtonIconStyled className="">
                <Button ariaLabel="PRINT CODE" type="button" variant="secondary" onClick={print}>
                  <PrinterIcon></PrinterIcon>
                  Print Code
                </Button>
              </ButtonIconStyled>

              <ButtonIconStyled className="">
                <Button ariaLabel="DOWNLOAD CODE" type="button" variant="secondary" onClick={getQR}>
                  <DownloadIcon></DownloadIcon>
                  Download Code
                </Button>
              </ButtonIconStyled>
            </QRButtonLayout>

          </div>
        </QrInfoStyled>

        {itemList.length === 0 && (
          <Fragment>
            <ViewRewardsOffersStyled>
              <p>You haven’t redeemed a reward or saved a qualifying offer. Load your rewards or offers before checkout.
              </p>

              <ViewRewardsOffersButtonStyled>
                <Button ariaLabel="VIEW REWARDS & OFFERS" type="button" variant="primary" onClick={viewRewardsOffersCallbackOnClick}>
                  VIEW REWARDS & OFFERS
                </Button>
              </ViewRewardsOffersButtonStyled>

            </ViewRewardsOffersStyled>

          </Fragment>
        )}

        {itemList.length > 0 && (
          <div class="items-content">
            <p>Select one loaded reward or qualifying offer below to use at checkout.</p>
            <RewardOffersContentStyled>
              {showOffers && (
                <Fragment>
                  {offers?.map((item: RewardOfferItemI) => (
                    <RewardOfferItemStyled>
                      <RewardOfferItem rewardOfferItem={item} itemId={itemSelectedId} callbackTapForDetails={callbackTapForDetails} callbackSubmit={callBackSubmit}></RewardOfferItem>
                    </RewardOfferItemStyled>
                  ))}
                </Fragment>
              )}
              
              <Link href={'#'} onClick={clearSelection} >Clear Selection</Link>

              <ViewRewardsOffersButtonStyled>
                <Button ariaLabel="VIEW REWARDS & OFFERS" type="button" variant="primary" fullWidth onClick={viewRewardsOffersCallbackOnClick}>
                  VIEW REWARDS & OFFERS
                </Button>
              </ViewRewardsOffersButtonStyled>
            </RewardOffersContentStyled>
          </div>
        )}

        <ViewOderOnlineButtonStyled>
          <Button type="button" fullWidth variant={'red'} onClick={viewOrderOnlineNowOnClick} >
            ORDER ONLINE NOW
          </Button>
        </ViewOderOnlineButtonStyled>
      </LayoutStyled>

      <RewardOfferModal
        id={idSelectedItemForDetailModal}
        isActive={isActiveRewardOfferDetailModal}
        isDisabledSubmitButton={isDisabledSubmitButtonDetailModal}
        title={selectedItemTitleForDetailModal}
        description={selectedItemDescriptionForDetailModal}
        expirationDate={selectedItemExpirationDateForDetailModal}
        imageUrl={selectedItemImageUrlForDetailModal}
        callbackOnSubmitButton={callBackSubmit}
        callbackOnCloseModal={hideModal}></RewardOfferModal>

      <Snackbar
        message={snackbarMessage}
        isActive={openSnackbar}
        type={snackbarType}
        timeout={6000}
        callbackOnClose={callbackOnCloseSnackbar}></Snackbar>
    </DelYeahContainer>
  );
};
